import { LocalizedText, useSourceLanguage } from "../i18n/LocalizedCopy";
import React from "react";
import { useAuth } from "../context/AuthContext";
import { PRELAUNCH_MODE } from "../config/prelaunch";
import FinanceDisabled from "../pages/FinanceDisabled";
import { isPresidentOfLia } from "../utils/admin";

export default function KycGate({ children }) {
  useSourceLanguage();
  const { user, loading } = useAuth();

  if (PRELAUNCH_MODE) {
    return <FinanceDisabled />;
  }

  if (loading) {
    return (
      <div className="app-loading"><LocalizedText source={"Vérification KYC en cours..."} /></div>
    );
  }

  if (!user) {
    return <FinanceDisabled />;
  }

  if (isPresidentOfLia(user)) {
    return children;
  }

  const hasKyc = user.access?.can_access_crypto;
  if (!hasKyc) {
    return <FinanceDisabled />;
  }

  return children;
}
